import React from "react";

function ContactBioData({contactProfile}) {

    return (
        <table className="table mb-0 mw-100 color-span">
            {contactProfile && (
                <tbody>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Names{" "}
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {contactProfile.full_name}
                            </span>{" "}
                        </td>
                    </tr>

                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Username
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {contactProfile.username}
                            </span>{" "}
                        </td>
                    </tr>
                   
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Account Status
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                            {contactProfile.is_secure=== 1? <span class="badge badge-success">SECURED</span>: <span class="badge badge-danger">{contactProfile.default_pin}</span>}
                            </span>{" "}
                        </td>
                    </tr>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Account Creation Date
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                            {contactProfile.created_at?.long_date}
                            </span>{" "}
                        </td>
                    </tr>
                
                </tbody>
            )}
        </table>
        
    );
}

export default ContactBioData;
